import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    // Estado original
    state: {
        plan: 0,
        plantwo: 0,
        multiplan: 0,
        multiplantwo: 0,
        planresult: 0
    },

    // Apenas mutations modificam estado && se usa com $store.commit
    mutations: {
        ADD_PLAN(state, payload) {
            state.plan = payload;
            console.log(state.plan);
        },
        ADD_PLAN_TWO(state, payload) {
            state.plantwo = payload;
            console.log(state.plantwo);
        },
        ADD_PLAN_MULTI(state, payload) {
            state.multiplan = payload;
            console.log(state.multiplan);
        },
        ADD_PLAN_MULTI_TWO(state, payload) {
            state.multiplantwo = payload;
            console.log(state.multiplantwo);
        },
        CLEAN_PLANS(state, payload) {
            state.multiplan = payload;
            state.multiplantwo = payload;
            state.plan = payload;
            state.plantwo = payload;
        },
        ADD_PLAN_RESULT(state, payload) {
            state.planresult = payload
        }
    },
    // Chama mutation que precisa ser async && se usa com $store.dispatch
    actions: {},

    // Computed properties
    getters: {
        getResult: (state) => {
            return state.planresult
        }
    },

    // Importacao de arquivos
    modules: {}
});
